const base  = window.location.href.includes("localhost")
    ? "https://adminmaster.test/" : "https://admin.esteticadecalzado.com/"


function getQueryParam(param) { const urlParams = new URLSearchParams(window.location.search); return urlParams.get(param); }
function scrollToId(id) {
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({
            behavior: "smooth", // scroll suave
            block: "start" // alinea al inicio del elemento

        });
    }
}

export const showMenu = () => {
    document.querySelector(".menu-container").style.left = "0"
}
export const hideMenu = () => {
    document.querySelector(".menu-container").style.left = "-100%"
}

export const fillButtons = evt=>{
    const element = evt.target;

    document.querySelectorAll(".banner button").forEach(element => {
        element.classList.remove("selected");
    })

    element.classList.add("selected")
    document.querySelectorAll(".reparacion,.ortopedia").forEach(element => {
        element.classList.add("d-none");
    })
    document.querySelector("."+element.value).classList.remove("d-none")
}

export const sendMessage = () => {
    let sendMessage = true;
    document.querySelectorAll(".contact-form input, .contact-form textarea").forEach(element=>{
        if (element.value === "") {
            element.classList.add("is-invalid");
            sendMessage = false;
        }else{
            element.classList.remove("is-invalid");
        }
    })

    if (sendMessage) {

        window.fetch(base+"api/messages?client_name="+
            document.getElementById("client_name").value+
            "&client_phone="+document.getElementById("client_phone").value+
            "&client_email="+document.getElementById("client_email").value+
            "&message="+document.getElementById("message").value, {
            method: "GET"
        }).then(response => response.text()).then(json => {
            alert("Muchas gracias por tu mensaje, intentaremos contactarte lo antes posible.")
            window.location.reload();
        })
    }



}

setTimeout(()=>{
    if (getQueryParam("target") != null){
        if (document.getElementById(getQueryParam("target")).parentElement.classList.contains("d-none")){
            document.querySelector(".banner button").nextElementSibling.click()
        }
        scrollToId(getQueryParam("target"));
    }
},200)